class ArticleTOC extends HTMLUListElement {
  constructor() {
    super();

    this.articleContainer = this.closest('.article-template');
    this.allHeadings = [...this.articleContainer.querySelectorAll('h2, h3, h4, h5, h6')];

    this.init();
  }

  addLinkToHeadings() {
    this.allHeadings.forEach((heading) => {
      const id = heading.textContent.toLowerCase().replace(/\s/g, '-');
      heading.setAttribute('id', id);
    });
  }

  populateTOC() {
    this.allHeadings.forEach((heading) => {
      const id = heading.getAttribute('id');
      const text = heading.textContent;

      const tocItem = document.createElement('li');
      tocItem.classList.add('toc-item');

      const tocLink = document.createElement('a');
      tocLink.classList.add('toc-link');
      tocLink.setAttribute('href', `#${ id }`);
      tocLink.textContent = text;

      tocItem.appendChild(tocLink);
      this.appendChild(tocItem);
    });
  }

  /**
   * @param {ready} Boolean 
   */
  setState({ ready }) {
    if (ready) {
      this.classList.add('ready');
    } else {
      this.classList.remove('ready');
    }
  }

  updateActiveElements() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const id = entry.target.getAttribute('id');
        const tocLink = this.querySelector(`[href="#${id}"]`);

        if (entry.isIntersecting) {
          tocLink.parentNode.classList.add('active');
        } else {
          tocLink.parentNode.classList.remove('active');
        }
      });
    }, observerOptions);
  
    this.allHeadings.forEach(heading => {
      observer.observe(heading);
    });
  }

  init() {
    if (!this.allHeadings.length) {
      return;
    }

    this.addLinkToHeadings();
    this.populateTOC();
    this.setState({ ready: true });

    this.updateActiveElements();
  }
}

customElements.define('article-toc', ArticleTOC, { extends: 'ul' });
